import { wellControlInstance } from '../api';
import {
  IAddressValues,
  ParameterGroup,
  RawSetpointGroup,
  RawSetpointGroupsResponse,
} from '../../types/SetpointManagerTypes';
import { buildApiHeaders } from '../../utilities/configUtils';
// import mockDataJson from './SetpointGroupsMockData.json';

// const mockData = mockDataJson as RawSetpointGroupsResponse;
const transformToParameterGroups = (data: RawSetpointGroup[]): ParameterGroup[] => {
  return data.map((group) => ({
    ...group,
    setpointGroup: group.setpointGroup.toString(),
    isExpanded: true,
    setpoints: group.setpoints.map((setpoint, index) => ({
      ...setpoint,
      id: `${group.setpointGroup}-${index}`,
      // Convert backUpLookUpValues to match expected format and handle null
      backUpLookUpValues: setpoint.backUpLookUpValues
        ? setpoint.backUpLookUpValues.map((item) => ({
            text: item.text,
            value: item.value.toString(),
          }))
        : null,
    })),
  }));
};

export const fetchParameterGroups = async (assetId: string): Promise<ParameterGroup[]> => {
  const headers = await buildApiHeaders();
  return await wellControlInstance
    .get('/Setpoints/GetSetpointGroups?assetId=' + assetId, {
      headers,
    })
    .then(function (response: { data: RawSetpointGroupsResponse }) {
      if (response && response.data && response.data.values && response.data.values.length > 0) {
        return transformToParameterGroups(response.data.values);
      } else {
        return [];
      }
    })
    .catch(() => {
      return [];
    });
};

// Simulate API delay
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchAlarmLegendItems = async () => {
  await delay(200);

  return [
    {
      type: 'high' as const,
      color: '#f97066',
      label: 'Alarm: high',
    },
    {
      type: 'low' as const,
      color: '#fdb022',
      label: 'Alarm: low',
    },
    {
      type: 'configured' as const,
      color: '#fff',
      label: 'Alarm configured',
    },
  ];
};

export const readControllerSetPoints = async (
  assetId: string,
  address: string[] = [],
  socketId: string,
): Promise<any> => {
  return await wellControlInstance
    .get(`/Setpoints?assetId=${assetId}&addresses=${address.join(',')}&socketId=${socketId}`)
    .then(function (response) {
      // Show a toast message if response code is 202
      if (response.status === 202) {
        return true;
      }
      return false;
    })
    .catch(() => {
      return [];
    });
};
export const writeControllerSetPoints = async (
  assetId: string,
  addressValues: IAddressValues = {},
  socketId: string,
): Promise<any> => {
  return await wellControlInstance.put('/Setpoints', { assetId, addressValues, socketId });
};

export const backupSetPoints = async (
  assetId: string,
  addressValues: IAddressValues = {},
  socketId: string,
): Promise<any> => {
  return await wellControlInstance
    .post('/Setpoints/BackupSetpoints', { assetId, addressValues, socketId })
    .then(function (response) {
      if (response.status === 202) {
        return true;
      }
      return false;
    })
    .catch(() => {
      return [];
    });
};
